import MatchConfirmationContainer from './match-confirmation-container';

export default MatchConfirmationContainer;
